export type HistoryPushEvent = CustomEvent<{ path: string }>;

export const historyEventBus = new EventTarget();

export const history: { push: (path: string) => void } = {
  push: (path: string) => historyEventBus.dispatchEvent(new CustomEvent('history:push', { detail: { path } })),
};
